import axios from 'axios';

import { LogService } from './log-service';

type ZendeskLoginInfo = {
  zenDeskSsoRoute: string;
  jwt: string;
  returnTo: string;
};

// Returns true if the SSO form was submitted, false if the request failed
// or returned an empty body. Callers that need to fire follow-up effects
// (analytics, notifications) should branch on the return value.
export const submitZendeskSsoForm = async (zenDeskLoginUrl: string): Promise<boolean> => {
  const zenDeskLoginInfo = await axios
    .get<ZendeskLoginInfo>(zenDeskLoginUrl)
    .then((response) => response?.data)
    .catch((cause) => {
      LogService.logError(new Error('Error retrieving login info for Zendesk', { cause }));
    });

  if (!zenDeskLoginInfo) {
    return false;
  }

  const form = document.createElement('form');
  form.action = `${zenDeskLoginInfo.zenDeskSsoRoute}/access/jwt`;
  form.method = 'post';
  form.target = '_blank';
  form.rel = 'noopener noreferrer';
  form.style.display = 'none';

  const jwtInput = document.createElement('input');
  jwtInput.value = zenDeskLoginInfo.jwt;
  jwtInput.name = 'jwt';
  form.appendChild(jwtInput);

  const returnToInput = document.createElement('input');
  returnToInput.value = zenDeskLoginInfo.returnTo;
  returnToInput.name = 'return_to';
  form.appendChild(returnToInput);

  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
  return true;
};
